import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';

/** RCP-466 — brands with their own logo; any other card shows the generic one. */
const CARD_BRANDS = [
  { match: 'visa', icon: 'ico_visa_card', label: 'Visa' },
  { match: 'master', icon: 'ico_mastercard_card', label: 'Mastercard' },
] as const;

const GENERIC_CARD = { icon: 'ico_credit_card', label: 'Card' } as const;

@Component({
  selector: 'lib-partial-hidden-credit-card',
  imports: [MatIconModule],
  templateUrl: './partial-hidden-credit-card.component.html',
  styleUrl: './partial-hidden-credit-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartialHiddenCreditCardComponent {
  cardType = input.required<string>();
  lastFourDigits = input.required<string>();

  /**
   * The type arrives as Microform's branded name (`mastercard`), the transient token's card type
   * (`MASTERCARD`) or whatever the order history stores, so it is matched loosely.
   */
  private brand = computed(() => {
    const type = (this.cardType() ?? '').toLowerCase().replace(/[\s_-]/g, '');
    return CARD_BRANDS.find((brand) => type.includes(brand.match)) ?? GENERIC_CARD;
  });

  creditCardIcon = computed(() => this.brand().icon);
  creditCardLabel = computed(() => this.brand().label);
}
